<ng-container *ngIf="emailCredentials">

    <div class="row no-gutters">
        <div class="col-md-10 col-lg-11 smp-title-thin-border mt-4 mb-2">
            {{ 'third_party_credentials_management.email.title.user_information' | translate }}
        </div>
    </div>

    <div class="row" >
        <div class="col-md-12 col-lg-6">
            <div class="row">
                <div class="col-sm-10">
                    <mat-form-field class="full-width">
                        <mat-label>{{ emailCredentials.trans.email | translate }}</mat-label>
                        <input id="{{idPrefix}}{{emailCredentials.trans.email}}"
                               type="text" matInput
                               [(ngModel)]="emailCredentials.email"
                               (blur)="onChange()"
                               [disabled]="disabled">
                    </mat-form-field>
                </div>
                <div class="col-sm-2">
                    <!-- PLACEHOLDER FOR ACTION BUTTONS-->
                </div>
            </div>
        </div>
    </div>

    <div class="row no-gutters">
        <div class="col-md-10 col-lg-11 smp-title-thin-border mt-4 mb-2">
            {{ 'third_party_credentials_management.email.title.server_information' | translate }}
        </div>
    </div>

    <div class="row" >
        <div class="col-md-12 col-lg-6">
            <div class="row">
                <div class="col-sm-10">
                    <mat-form-field class="full-width">
                        <mat-label>{{ emailCredentials.trans.provider | translate }}</mat-label>
                        <mat-select id="{{idPrefix}}{{emailCredentials.trans.provider}}"
                                    [(ngModel)]="selectedProvider"
                                    (ngModelChange)="onProviderChange()"
                                    [disabled]="disabled">
                            <mat-option *ngFor="let item of emailProviders.items; let providerIdx = index"
                                        id="{{idPrefix}}{{emailCredentials.trans.provider}}.item_{{providerIdx}}"
                                        [value]="item">
                                {{ item.provider }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-sm-2">
                    <!-- PLACEHOLDER FOR ACTION BUTTONS-->
                </div>
            </div>
        </div>

        <div class="col-md-12 col-lg-6">
            <div class="row">
                <div class="col-sm-10">
                    <mat-form-field class="full-width">
                        <mat-label>{{ emailCredentials.trans.host | translate }}</mat-label>
                        <input id="{{idPrefix}}{{emailCredentials.trans.host}}"
                               type="text" matInput
                               [(ngModel)]="emailCredentials.host"
                               (blur)="onChange()"
                               [disabled]="disabled">
                    </mat-form-field>
                </div>
                <div class="col-sm-2">
                    <!-- PLACEHOLDER FOR ACTION BUTTONS-->
                </div>
            </div>
        </div>
    </div>

    <div class="row" >
        <div class="col-md-12 col-lg-6">
            <div class="row">
                <div class="col-sm-10">
                    <mat-form-field class="full-width">
                        <mat-label>{{ emailCredentials.trans.security | translate }}</mat-label>
                        <mat-select id="{{idPrefix}}{{emailCredentials.trans.security}}"
                                    [(ngModel)]="emailCredentials.security"
                                    (ngModelChange)="onChange()"
                                    [disabled]="disabled">
                            <mat-option id="{{idPrefix}}{{emailCredentials.trans.security}}.item_empty" [value]="null"></mat-option>
                            <mat-option *ngFor="let item of securityOptions; let securityIdx = index"
                                        id="{{idPrefix}}{{emailCredentials.trans.security}}.item_{{securityIdx}}"
                                        [value]="item">{{ item }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-sm-2">
                    <!-- PLACEHOLDER FOR ACTION BUTTONS-->
                </div>
            </div>
        </div>

        <div class="col-md-12 col-lg-6">
            <div class="row">
                <div class="col-sm-10">
                    <mat-form-field class="full-width">
                        <mat-label>{{ emailCredentials.trans.port | translate }}</mat-label>
                        <input id="{{idPrefix}}{{emailCredentials.trans.port}}"
                               type="text" matInput
                               only-digits
                               [(ngModel)]="emailCredentials.port"
                               (blur)="onChange()"
                               [disabled]="disabled">
                    </mat-form-field>
                </div>
                <div class="col-sm-2">
                    <!-- PLACEHOLDER FOR ACTION BUTTONS-->
                </div>
            </div>
        </div>
    </div>

    <div class="row no-gutters">
        <div class="col-md-10 col-lg-11 smp-title-thin-border mt-4 mb-2">
            {{ 'third_party_credentials_management.email.title.login_information' | translate }}
        </div>
    </div>

    <div class="row" >
        <div class="col-md-12 col-lg-6">
            <div class="row">
                <div class="col-sm-10">
                    <mat-form-field class="full-width">
                        <mat-label>{{ emailCredentials.trans.user | translate }}</mat-label>
                        <input id="{{idPrefix}}{{emailCredentials.trans.user}}"
                               type="text" matInput
                               [(ngModel)]="emailCredentials.user"
                               (blur)="onChange()"
                               [disabled]="disabled">
                    </mat-form-field>
                </div>
                <div class="col-sm-2">
                    <!-- PLACEHOLDER FOR ACTION BUTTONS-->
                </div>
            </div>
        </div>

        <div class="col-md-12 col-lg-6">
            <div class="row">
                <div class="col-sm-10">
                    <mat-form-field class="full-width">
                        <mat-label>{{ emailCredentials.trans.password | translate }}</mat-label>
                        <input id="{{idPrefix}}{{emailCredentials.trans.password}}"
                               type="password" matInput
                               [(ngModel)]="emailCredentials.password"
                               (blur)="onChange()"
                               [disabled]="disabled">
                    </mat-form-field>
                </div>
                <div class="col-sm-2 align-self-center">
                    <!-- PLACEHOLDER FOR ACTION BUTTONS-->
                    <button id="{{idPrefix}}btn.send_test_email"
                            mat-icon-button
                            color="primary"
                            aria-label="Send test email"
                            (click)="sendTestEmail()"
                            [matTooltip]="'third_party_credentials_management.email.btn.send_test_email' | translate"
                            [disabled]="disabled || disableTestEmailBtn">
                        <mat-icon>email</mat-icon>
                    </button>
                </div>
            </div>
        </div>
    </div>


    <!-- BUTTON ROW -->

    <div class="row mt-5">
        <div class="offset-lg-6 col-xs-12 col-md-6 col-lg-3">
            <a id="{{idPrefix}}btn.cancel"
               mat-stroked-button
               color="primary"
               class="full-width"
               (click)="cancelEditing()">
                {{ 'common.btn.cancel' | translate | uppercase }}
            </a>
        </div>

        <div class="col-xs-12 col-md-6 col-lg-3">
            <button id="{{idPrefix}}btn.save"
                    mat-flat-button
                    color="accent"
                    class="full-width"
                    (click)="saveCredentials()"
                    [disabled]="disabled">
                {{ 'common.btn.save' | translate | uppercase }}
            </button>
        </div>
    </div>

</ng-container>
